import { Button } from "@mui/material";

export default function ClearStorageSetting() {
    const handleClick = () => {
        localStorage.clear();
        sessionStorage.clear();
    };
    return <Button variant="contained" onClick={handleClick}>Reset Settings to Default</Button>;
}
